export const LOAD_PAYMENTS_FILTERS = '[ACTIVITY_PAYMENTS_FILTERS]: Load payments filters';
export const UPDATE_PAYMENTS_FILTERS = 'ACTIVITY_PAYMENTS_FILTERS]: Update payments filters';
